<template>
  <div class="vm-auth-door mq ml-0-16 mr-0-16 flex-box flex-center flex-direction-column mt-16-0">
    <p class="mq fs-14-12 black-8">{{$t('c.AuthDoor.text1')}}</p>
    <p class="mq fs-14-12 black-8 mt8">{{$t('c.AuthDoor.text2')}}
      <router-link class="purple" to="/album/248b4bb2c9b111e9a9bb52540025c377">
        {{$t('c.AuthDoor.text3')}}
      </router-link>
    </p>
    <btn class="mt16" v-if="is_show_btn" @click.native="tap">{{$t('c.AuthDoor.text4')}}</btn>
  </div>
</template>

<script>
export default {
  name: "auth-box",
  props: {
    is_show_btn: {
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  mounted() {},
  methods: {
    tap(){
      // let text = `你好，我已阅读上述认证流程，特来申请创作者认证，这是我在其他平台的主页网址：`;
      // this.$router.push(
      //   `/message/27f7cea2370d11e8ae8852540025c377?is_keyboard_up=1&text=${text}`
      // );
      this.$router.push(`/apply/certify`);
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-auth-door{
    background: rgba(0, 0, 0, 0.02);
    border-radius: 5px;
    height:170px;
    box-sizing:border-box;
}
</style>
